module.exports = __webpack_public_path__ + "060d0b3d5c03abf6d6946ffdf13304da.svg";